import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[giqWholeNumberOnly]',
    standalone: false
})
export class WholeNumberOnlyDirective {
  constructor() {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === '.') {
      event.preventDefault();
    }

    if (['e', 'E', '+', '-'].includes(event.key)) {
      event.preventDefault();
      return;
    }

  }
  @HostListener('paste', ['$event'])
  onPasteEvent(event: any) {
    if (!new RegExp(/^\d+$/).test(event.clipboardData?.getData('text') ?? '')) {
      event.preventDefault();
    }
  }
}
